import EditCapability from '@codeDelivery/views/EditCapability/EditCapability';

export default EditCapability;
